/*  ____                        _       
   |  _ \ ___  __ _ _ __  _   _| |_ ___ 
   | |_) / _ \/ _` | '_ \| | | | __/ __|
   |  __/  __/ (_| | | | | |_| | |_\__ \
   |_|   \___|\__,_|_| |_|\__,_|\__|___/
   https://peanuts.no
*/

(function ($) {

    // Adding file type icons to links
    var fileTypesIcons = [
        [".pdf", "zmdi-collection-pdf"],
        [".doc", "zmdi-collection-text"],
        [".odt", "zmdi-collection-text"],
        [".ppt", "zmdi-fullscreen-alt"],
        [".odp", "zmdi-fullscreen-alt"],
        [".xls", "zmdi-grid"],
        [".ods", "zmdi-grid"],
        ["docs.google.com", "zmdi-google-drive"]
    ];
    $('a[href*="/globalassets/"],a[href*="/siteassets/"]').each(function () {
        var href = $(this).attr("href");
        if ($(this).hasClass("no-icon")) return;
        if ($(this).find("i").length > 0) return;
        if ($(this).attr("class")) return;

        for (var i = 0; i < fileTypesIcons.length; i++) {
            var fileTypeIcon = fileTypesIcons[i];
            if (href.indexOf(fileTypeIcon[0]) === -1) continue;

            if ($(this).find("h3").length > 0) {
                $(this).find("h3").append(' <i class="zmdi ' + fileTypeIcon[1] + '"></i>');
            } else {
                $(this).append(' <i class="zmdi ' + fileTypeIcon[1] + '"></i>');
            }
        }
    });

})(jQuery);